import { Component, EventEmitter, Output } from '@angular/core';
import { DropdownComponent } from '../../ui/dropdown/dropdown';
import { DropdownItemTwoComponent } from '../../ui/dropdown/dropdown-item/dropdown-item-two';

/**
 * The "Share the love" button and its Create post / blog / event dropdown,
 * shared by AppHeader and AppDashboardHeader. Post and event creation are
 * emitted so the header can open the shared CreateContentModals.
 */
@Component({
  selector: 'app-share-love-menu',
  imports: [DropdownComponent, DropdownItemTwoComponent],
  templateUrl: './share-love-menu.html',
})
export class ShareLoveMenu {
  @Output() createPost = new EventEmitter<void>();
  @Output() createEvent = new EventEmitter<void>();
  /** Fires when the dropdown opens, so the header can close its other menus. */
  @Output() opened = new EventEmitter<void>();

  isOpen = false;

  toggle(): void {
    this.isOpen = !this.isOpen;
    if (this.isOpen) this.opened.emit();
  }

  close(): void { this.isOpen = false; }
}
